import { usePreferredLanguageSync } from "../hooks/usePreferredLanguageSync";

/**
 * Syncs the signed-in user's UI language with UsersTable
 * (restore on login, save on manual switch)
 */
export const PreferredLanguageSync = () => {
  usePreferredLanguageSync();

  // This component doesn't render anything visible
  return null;
};

export default PreferredLanguageSync;
